import request from '@/utils/request'

export function getContractList(params) {
    return request({
        url: '/v2/sec/contractList/getContractList',
        method: 'post',
        data: params
    })
}
export function getContractLock(params) {
    return request({
        url: '/v2/sec/contractList/getContractLock',
        method: 'post',
        data: params
    })
}